import React, { useState} from 'react';
import {
    validateServiceInfo,
    validateServiceIdentificationInfo,
  } from '../../utils/validation';
  import { initialCarteFormData } from './../../utils/formData';

function CarteForm() {

    const [currentStep, setCurrentStep] = useState(1);
            const [errors, setErrors] = useState({});
            const [formData, setFormData] = useState(initialCarteFormData);
        
        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({
            ...formData,
            [name]: value,
            });
        };
    
        const validateFields = () => {
            let newErrors = {};
            newErrors = validateServiceInfo(formData);
            setErrors(newErrors);
        }
    
        const handleSubmit = (e) => {
            e.preventDefault();
            if (validateFields()) {
            alert('Formulaire envoyé avec succès');
            }
        };

  return (
    <div className="inscription-container">
      <form onSubmit={handleSubmit} className='inscription-form'>
          <div className="form-step">
            <h2 className='inscription-title'>Ajout d'une carte</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Numéro carte  :</label>
                    <input type="text" name="cardNo" value={formData.cardNo} onChange={handleChange} placeholder='Ex: 1254 xxxx ....' />
                    {errors.cardNo && <p className="error">{errors.cardNo}</p>}
                </div>
                <div className="form-group">
                    <label>Balance</label>
                    <input type="text" name="balance" value={formData.balance} onChange={handleChange} placeholder='Ex: 1.00' />
                    {errors.balance && <p className="error">{errors.balance}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Categorie</label>
                    <select name="typeCarte" value={formData.typeCarte} onChange={handleChange}>
                        <option value="mineur">Mineurs </option>
                        <option value="majeur">Majeurs</option>
                    </select>
                    {errors.typeCarte && <p className="error">{errors.typeCarte}</p>}
                </div>
                <div className="form-group">
                    <label>Date d'expiration</label>
                    <input type="date" name="dateExpiration" value={formData.dateExpiration} onChange={handleChange} />
                    {errors.dateExpiration && <span className="error">{errors.dateExpiration}</span>}
                </div>
            </div>
            {/* <div className="form-row">
                <div className="form-group">
                    <label>Institution</label>
                    <select name="institution" value={formData.institution} onChange={handleChange}>
                        <option value="labo">Labo 5</option>
                        <option value="clinique">Pharmacie</option>
                        <option value="pediatrie">Pédiatrie</option>
                    </select>
                    {errors.institution && <p className="error">{errors.institution}</p>}
                </div>
                <div className="form-group">
                    <label>Service couvert :</label>
                    <select name="service" value={formData.service} onChange={handleChange}>
                        <option value="idThier">Soins optique</option>
                        <option value="idHam">Radiographie</option>
                        <option value="idIbra">Chirrurgie dentaire</option>
                    </select>
                    {errors.service && <p className="error">{errors.service}</p>}
                </div>
                
            </div> */}
          </div>

          <button type="submit" className="submit-button">
             Enregistrer
          </button>
        
      </form>
    </div>
  )
}

export default CarteForm